import { useEffect, useState, type FC } from "react";
import { motion } from "motion/react";

interface BubbleProps {
  left: number;
  delay: number;
  size: number;
  duration: number;
  maxRise: number;
}

const Bubble: FC<BubbleProps> = ({ left, delay, size, duration, maxRise }) => {
  return (
    <motion.div
      className="absolute rounded-full bg-white/30 backdrop-blur-sm pointer-events-none"
      style={{
        left: `${left}%`,
        bottom: "-10px",
        width: size,
        height: size,
        boxShadow: "0 0 8px rgba(255,255,255,0.8)",
      }}
      initial={{ y: 0, opacity: 0.9, scale: 0.6 }}
      animate={{
        y: -maxRise,
        x: [0, 6, -5, 3, 0],
        opacity: [0.9, 0.9, 0],
        scale: [0.6, 1.1, 0.8],
      }}
      transition={{
        duration: duration,
        delay: delay,
        repeat: Infinity,
        repeatDelay: Math.random() * 1.5 + 0.5,
        ease: "easeOut",
      }}
    />
  );
};

export const ChampagneBubbles: FC<{ className?: string }> = ({ className }) => {
  const [bubbles, setBubbles] = useState<any[]>([]);

  useEffect(() => {
    const newBubbles = Array.from({ length: 18 }, (_, i) => ({
      id: i,
      left: 42 + Math.random() * 18,
      delay: Math.random() * 3,
      size: 4 + Math.random() * 9,
      duration: 2.2 + Math.random() * 1.8,
      maxRise: 110 + Math.random() * 95,
    }));

    setBubbles(newBubbles);
  }, []);

  return (
    <div className={className} style={{ zIndex: 10 }}>
      {bubbles.map((bubble) => (
        <Bubble
          key={bubble.id}
          left={bubble.left}
          delay={bubble.delay}
          size={bubble.size}
          duration={bubble.duration}
          maxRise={bubble.maxRise}
        />
      ))}
    </div>
  );
};
